import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { FavoriteKind } from '../favorites.util';
import { FavoritesService } from './favorites.service';

/** Resume half of the favorite login-gate (see `redirectToSignIn()` in
 *  `auth-redirect.util.ts`) — call from a gated page's `ngOnInit` param
 *  subscription. Re-issues the favorite the visitor tried to save before
 *  being bounced to /auth/login, then strips the flags so back/refresh doesn't
 *  replay it. */
export function resumeFavoriteToggle(
  params: Record<string, string | undefined>,
  router: Router,
  route: ActivatedRoute,
  auth: AuthService,
  favorites: FavoritesService,
): void {
  const kind = params['favKind'] as FavoriteKind | undefined;
  const rawId = params['favId'];
  if (!kind || !rawId || !auth.currentUser) return;
  void favorites.addFavorite(kind, kind === 'poi' ? rawId : Number(rawId));
  router.navigate([], {
    relativeTo: route,
    queryParams: { favKind: null, favId: null },
    queryParamsHandling: 'merge',
    replaceUrl: true,
  });
}
